import React, { useState, useEffect } from "react";
import Login from "./Login";
import Dashboard from "./Dashboard";
import { adminApi, getToken, setToken } from "./adminApi";
import { Toaster } from "../components/ui/toaster";

export default function AdminApp() {
  const [username, setUsername] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const tk = getToken();
    if (!tk) { setChecking(false); return; }
    adminApi.me()
      .then((r) => setUsername(r.data.username))
      .catch(() => setToken(null))
      .finally(() => setChecking(false));
  }, []);

  if (checking) {
    return <div className="min-h-screen flex items-center justify-center bg-[#1C1815] text-[#C9A24B]">Caricamento...</div>;
  }

  return (
    <>
      {username
        ? <Dashboard username={username} onLogout={() => setUsername(null)} />
        : <Login onLogin={setUsername} />}
      <Toaster />
    </>
  );
}